import BX from 'BX';
import Vue from 'vue';
import { getAbilityPromise } from './defineAbility';
import * as store from './store'

BX.namespace('MiniApp');

BX.MiniApp.init = (data = {}) => document.querySelectorAll('[data-mini-app]')
	.forEach((element) => {
		element.removeAttribute('data-mini-app');

		Promise.all([
			store.ready,
			getAbilityPromise
		]).then(() => new Vue({
			name: 'MiniApp',
			data: () => data,
			el: element,
		}));
	});
